import React, { Component } from "react"
import Utils from "../../utils/node.utils"
import { store as tStore } from "../Store/Store"
import { Link, navigate } from "gatsby"
import WishlistButton from "../Shared/WishlistButton/WishlistButton"

export default class CartView extends Component {
  state = {
    cart: [],
    shippingGroups: [],
    products: [],
    countries: [],
    discountCode: "",
    discountDisabled: true,
    checkoutDisabled: false,
    errors: [],
    total: {
      value: "0.00",
      currency: "EUR",
    },
    formValues: {
      country: "ES",
      shipping_country: "",
      discount_code: "",
    },
  }

  componentDidMount() {
    let { formValues } = this.state

    window.addEventListener("beforeunload", this.componentCleanup)
    const cart = Utils.GetCart("cart-items")

    if (!cart.length || cart.length === 0) {
      return
    }

    formValues = Utils.MergeFormValues(
      formValues,
      JSON.parse(localStorage.getItem("form-values"))
    )

    this.unsubscribe = tStore.subscribe(this.storeUpdate)
    this.setState(
      {
        cart: cart.sort(compareProductsByID),
        formValues: formValues,
        discountCode: formValues.discount_code,
      },
      this.storeUpdate
    )
  }

  componentDidUpdate = () => {
    const { country } = this.props
    const { formValues } = this.state

    if (country) {
      if (this.hasShippingCountry()) {
        if (country !== formValues.shipping_country) {
          formValues.shipping_country = country
          this.setState(
            {
              formValues: formValues,
              shippingGroup: undefined,
              shippingSubGroup: undefined,
            },
            this.fetchProducts
          )
        }
      } else {
        if (country !== formValues.country) {
          formValues.country = country
          this.setState(
            {
              formValues: formValues,
              shippingGroup: undefined,
              shippingSubGroup: undefined,
            },
            this.fetchProducts
          )
        }
      }
    }
  }

  componentWillUnmount() {
    this.componentCleanup()
  }

  componentCleanup = () => {
    const { staticData } = this.props
    const { formValues } = this.state

    if (formValues && !staticData) {
      localStorage.setItem("form-values", JSON.stringify(formValues))
    }

    if (this.timeoutID) {
      clearTimeout(this.timeoutID)
    }

    Utils.CancelToken(this.productCancelToken)
    Utils.CancelToken(this.discountCancelToken)
    Utils.CancelToken(this.countryCancelToken)
    Utils.CancelToken(this.cartCancelToken)
    Utils.RemoveShippingNotification()
    Utils.Unsubscribe(this.unsubscribe)
  }

  storeUpdate = () => {
    const { t } = this.state
    const storeState = tStore.getState()

    if (storeState.t && storeState.t !== t) {
      this.setState(
        {
          t: storeState.t,
        },
        this.loadInitialData
      )
    }
  }

  loadInitialData = () => {
    const { productsLoaded, countriesLoaded, t, formValues } = this.state

    if (!t) {
      console.warn("Cannot init, not authenticated")
      return
    }

    if (formValues.discount_code && formValues.discount_code !== "") {
      this.discountCancelToken = Utils.FetchDiscount(
        formValues.discount_code,
        t,
        this.setDiscount
      )
    } else {
      if (!productsLoaded) {
        this.fetchProducts()
        this.setState({
          productsLoaded: true,
        })
      }
    }

    if (!countriesLoaded) {
      this.fetchCountries()
      this.setState({
        countriesLoaded: true,
      })
    }
  }

  fetchCountries = () => {
    const { language } = this.props
    const { t } = this.state
    if (!t) {
      console.warn("Cannot fetch countries, not authenticated")
      return
    }
    this.countryCancelToken = Utils.FetchCountries(
      language,
      t,
      this.setCountries
    )
  }

  setCountries = countries => {
    const { onCountriesChange } = this.props

    this.setState({
      countries: countries,
    })
    if (onCountriesChange) {
      onCountriesChange(countries)
    }
  }

  hasShippingCountry = () => {
    const { formValues } = this.state
    return formValues.shipping_country && formValues.shipping_country !== ""
  }

  getCountryFormValue = () => {
    const { formValues } = this.state

    if (this.hasShippingCountry()) {
      return formValues.shipping_country
    }
    return formValues.country
  }

  handleAPIError = err => {
    this.loading = false
    if (err.response && err.response.status) {
      if (err.response.status == 404 || err.response.status == 400) {
        localStorage.removeItem("cart-items")
        this.setState({
          cart: [],
        })
        return
      }
    }
    Utils.LogAxiosError(err)
  }

  fetchProducts = () => {
    const { language } = this.props
    const { cart, shippingGroup, shippingSubGroup, t, formValues } = this.state
    if (!t) {
      console.warn("Cannot fetch products, not authenticated")
      return
    }
    this.loading = true

    this.productCancelToken = Utils.CheckProducts(
      Utils.CartToCheck(
        cart,
        this.getCountryFormValue(),
        shippingGroup,
        shippingSubGroup,
        formValues.discount_code
      ),
      language,
      t,
      this.setProducts,
      this.handleAPIError
    )
  }

  setProducts = checkResult => {
    const {
      language,
      contentMap,
      commonContentMap,
      onProductsChange,
      onShippingGroupChange,
      onStockIssue,
    } = this.props
    const { cart, formValues, countries } = this.state

    const locale = Utils.LanguageToLocale(language)
    let { shippingGroup, shippingSubGroup } = this.state
    let cb
    let removeDiscount = false
    let checkoutDisabled = false
    let insufficientStock = false

    this.loading = false

    if (!checkResult.products || checkResult.products.length === 0) {
      console.warn("Could not read product details")
      this.setState({
        products: [],
      })
      return
    }

    if (cart.length < checkResult.products.length) {
      console.warn("Request was for old data, discarding")
      return
    }

    if (!shippingGroup || !shippingSubGroup) {
      cb = this.fetchProducts
      // No definitive selection yet
      // The discount value contains the minimum free shipping value, so remove
      // Also disable the checkout button
      removeDiscount = true
      checkoutDisabled = true
    } else {
      if (onShippingGroupChange) {
        onShippingGroupChange(shippingGroup, shippingSubGroup)
      }
    }

    if (checkResult.shipping_groups && checkResult.shipping_groups.length > 0) {
      shippingGroup = checkResult.shipping_groups[0]
      if (shippingGroup.sub_groups.length > 0) {
        shippingSubGroup = shippingGroup.sub_groups[0]
      }
    } else {
      // Don't fetch again now, country doesn't have a shipping group
      cb = undefined
      console.error(
        `Country ${formValues.country} does not have a shipping group`
      )
      // Ensure that they are deleted everywhere
      shippingGroup = undefined
      shippingSubGroup = undefined
      if (onShippingGroupChange) {
        onShippingGroupChange(shippingGroup, shippingSubGroup)
      }
    }

    if (removeDiscount) {
      if (shippingSubGroup) {
        this.free_shipping_price = shippingSubGroup.price.discount_value
        shippingSubGroup.price.discount_value = ""
      }
    }

    const newProducts = checkResult.products
      .sort(compareProductsByID)
      .map((item, index) => {
        let options = []

        if (item.sequence) {
          for (let i in item.sequence) {
            const variationOption = item.sequence[i]
            if (
              variationOption.option &&
              !variationOption.option.id.startsWith("Custom:")
            ) {
              options.push(
                Utils.GetContentKeyValueWithDefault(
                  variationOption.option.content,
                  "name",
                  locale
                )
              )
            }
          }
        }

        const cartItem = cart[index]
        const cartVariations = cartItem.variations
        if (cartVariations) {
          for (let variationID in cartVariations) {
            const variationOptionID = cartVariations[variationID]
            if (variationOptionID.startsWith("Custom:")) {
              options.push(variationOptionID.slice(7))
            }
          }
        }

        const optionString =
          options.length !== 0 ? "(" + options.join(", ") + ")" : ""

        let oldQuantity
        if (cartItem.quantity > item.data.quantity) {
          oldQuantity = cartItem.quantity
          if (item.data.quantity === 0) {
            checkoutDisabled = true
            insufficientStock = true
            cartItem.quantity = 1
          }
        }

        return {
          id: item.id,
          sequence: item.sequence,
          slug: item.slug,
          name: Utils.GetContentKeyValueWithDefault(
            item.content,
            "name",
            locale
          ),
          thumbnail: Utils.GetContentKeyValue(item.content, "thumbnails"),
          quantity: item.data.quantity,
          oldQuantity: oldQuantity,
          price: item.data.price,
          variations: item.variations,
          totalPrice: item.data.total_price,
          optionString: optionString,
        }
      })

    if (checkoutDisabled && insufficientStock && onStockIssue) {
      onStockIssue()
      return
    }

    Utils.SetCart("cart-items", cart)
    if (onProductsChange) {
      onProductsChange(newProducts)
    }

    const total = cb ? { currency: "", value: "" } : checkResult.total

    if (!cb) {
      if (shippingSubGroup && !onStockIssue) {
        let totalFloat = parseFloat(total.value)
        if (total.discount_value && total.discount_value !== "") {
          totalFloat -= parseFloat(total.discount_value)
          if (
            shippingSubGroup.price.value ===
            shippingSubGroup.price.discount_value
          ) {
            // Need to add shipping price again
            totalFloat += parseFloat(shippingSubGroup.price.value)
          }
        }
        const freeShippingFloat =
          parseFloat(this.free_shipping_price) +
          parseFloat(shippingSubGroup.price.value)

        if (totalFloat < freeShippingFloat) {
          this.timeoutID = Utils.DisplayShippingNotification(
            contentMap,
            commonContentMap,
            formValues.country,
            countries,
            {
              totalFloat: totalFloat,
              freeShippingFloat: freeShippingFloat,
              currency: total.currency,
            }
          )
        }
      }
    }

    this.setState(
      {
        cart: cart,
        total: total,
        shippingGroup: shippingGroup,
        shippingSubGroup: shippingSubGroup,
        products: newProducts,
        checkoutDisabled: checkoutDisabled,
      },
      cb
    )
  }

  createHeaderNameCSS = () => {
    const { staticData } = this.props
    return staticData
      ? "col-3 col-md-6 col-lg-6 text-truncate font-weight-bold"
      : "col-3 col-md-6 col-lg-4 text-truncate font-weight-bold"
  }

  createHeader = () => {
    const { contentMap } = this.props
    return (
      <div className="row cart-item align-items-center">
        <div className={this.createHeaderNameCSS()}>
          {contentMap.table_name.value}
        </div>
        <div className="col-3 col-md-2 text-truncate font-weight-bold text-right">
          {contentMap.table_quantity.value}
        </div>
        <div className="col-3 col-md-2 text-truncate font-weight-bold text-right">
          {contentMap.table_price.value}
        </div>
        <div className="col-3 col-md-2 text-truncate font-weight-bold text-right">
          {contentMap.table_total.value}
        </div>
      </div>
    )
  }

  createThumbnail = (item, link) => {
    const { staticData } = this.props

    if (staticData) {
      return (
        <img
          src={item.thumbnail}
          alt={item.name}
          title={item.name}
          className="img-fluid"
        />
      )
    }
    return (
      <Link to={link} title={item.name}>
        <img
          src={item.thumbnail}
          alt={item.name}
          title={item.name}
          className="img-fluid"
        />
      </Link>
    )
  }

  createName = (item, link) => {
    const { staticData } = this.props

    if (staticData) {
      return item.name + " " + item.optionString
    }
    return (
      <Link to={link} title={item.name} className="cart-link">
        {item.name} {item.optionString}
      </Link>
    )
  }

  getPrice = item => {
    if (item.quantity === 0) {
      return ""
    }
    return Utils.GetDisplayPrice(item.price)
  }

  getTotalPrice = item => {
    if (item.quantity === 0) {
      return ""
    }

    return Utils.GetDisplayPrice(item.totalPrice)
  }

  reduceProducts = cart => {
    const { products } = this.state

    if (cart.length !== products.length) {
      let newProducts = []
      let cartMap = {}

      for (let i in cart) {
        const cartItem = cart[i]
        const productKey = Utils.CreateProductKey(
          cartItem.id,
          cartItem.variations
        )
        cartMap[productKey] = true
      }

      for (let i in products) {
        const product = products[i]
        const productKey = Utils.CreateProductKeyFromList(
          product.id,
          product.sequence
        )
        if (cartMap[productKey]) {
          newProducts.push(product)
        }
      }
      return newProducts
    }
    return products
  }

  onUpdateCart = cart => {
    if (cart) {
      this.setState(
        {
          cart: cart,
          products: this.reduceProducts(cart),
        },
        this.afterUpdateCart
      )
    }
  }

  afterUpdateCart = () => {
    this.state.shippingSubGroup = undefined
    this.fetchProducts()
  }

  onAdd = (product, sequence) => {
    const { commonContentMap } = this.props
    const { t } = this.state

    if (this.loading) {
      return
    }

    Utils.RemoveShippingNotification()
    this.cartCancelToken = Utils.AddToCart(
      product,
      sequence,
      "cart-items",
      false,
      commonContentMap,
      this.onUpdateCart,
      t
    )
  }

  onRemove = (product, sequence) => {
    const { commonContentMap } = this.props

    if (this.loading) {
      return
    }

    Utils.RemoveFromCart(
      product,
      sequence,
      "cart-items",
      false,
      commonContentMap,
      this.onUpdateCart
    )
  }

  getAddButton = (item, variations) => {
    const { commonContentMap, staticData } = this.props

    if (staticData) {
      return null
    }

    if (item.quantity === 0) {
      return null
    }

    return (
      <div
        title={commonContentMap.button_add_more.value}
        className="btn btn-border col-6 mt-1 mt-lg-0 col-lg-1"
        onClick={() => {
          this.onAdd(item, variations)
        }}
      >
        <div className="d-none d-lg-block">
          <i
            className={"fa fa-plus"}
            alt={commonContentMap.button_add_more.value}
          />
        </div>
        <div className="d-lg-none d-block">
          {commonContentMap.button_add_more.value}
        </div>
      </div>
    )
  }

  getRemoveButton = (item, variations) => {
    const { commonContentMap, staticData } = this.props

    if (staticData) {
      return
    }

    return (
      <div
        title={commonContentMap.button_remove.value}
        className="btn btn-dark mt-1 mt-lg-0 col-6 col-lg-1"
        onClick={() => {
          this.onRemove(item, variations)
        }}
      >
        <div className="d-none d-lg-block">
          <i
            className={"fa fa-minus"}
            alt={commonContentMap.button_remove.value}
          />
        </div>
        <div className="d-lg-none d-block">
          {commonContentMap.button_remove.value}
        </div>
      </div>
    )
  }

  getWishlistButton = item => {
    const { language, commonContentMap, staticData } = this.props

    if (staticData) {
      return null
    }

    if (item.quantity !== 0) {
      return null
    }

    return (
      <WishlistButton
        id={item.id}
        language={language}
        margin="col-6 col-lg-1 mt-1 mt-lg-0 text-truncate"
        commonContentMap={commonContentMap}
        showText={true}
      />
    )
  }

  handleChange = event => {
    const { onCountryChange } = this.props
    const { formValues } = this.state
    let {
      shippingGroup,
      shippingSubGroup,
      discountCode,
      discountDisabled,
    } = this.state

    switch (event.target.id) {
      case "country":
        shippingGroup = undefined
        shippingSubGroup = undefined
        if (this.hasShippingCountry()) {
          formValues.shipping_country = event.target.value
        } else {
          formValues.country = event.target.value
        }
        if (onCountryChange) {
          onCountryChange(formValues.country, formValues.shipping_country)
        }
        Utils.RemoveShippingNotification()
        this.setState(
          {
            formValues: formValues,
            shippingGroup: shippingGroup,
            shippingSubGroup: shippingSubGroup,
          },
          this.fetchProducts
        )
        break
      case "discount_code":
        discountCode = event.target.value
        discountDisabled = discountCode === ""
        this.setState({
          discountCode: discountCode,
          discountDisabled: discountDisabled,
        })
        break
    }
  }

  getShippingPrice = () => {
    const { shippingSubGroup } = this.state

    if (!shippingSubGroup) {
      return ""
    }

    return Utils.GetDisplayPrice(shippingSubGroup.price)
  }

  getShippingPriceCSS = () => {
    const { staticData } = this.props

    return staticData
      ? "col-6 col-md-6 col-lg-8 text-right"
      : "col-6 col-md-6 text-right"
  }

  createShippingRow() {
    const { commonContentMap } = this.props
    const { countries } = this.state

    const value = this.getCountryFormValue()

    return (
      <div className="row align-items-center cart-item" id="shipping_list">
        <div className="col-6 col-md-6 col-lg-4">
          <label htmlFor="country_list_div">
            {commonContentMap.shipping.value}
          </label>
          <div className="row d-flex align-items-start" name="country_list_div">
            <select
              id={"country"}
              name={"country"}
              value={value}
              className="col-12 form-control"
              onChange={this.handleChange}
            >
              {Utils.GetCountryOptions(countries)}
            </select>
          </div>
        </div>
        <div className={this.getShippingPriceCSS()}>
          {this.getShippingPrice()}
        </div>
      </div>
    )
  }

  getQuantity = item => {
    const { contentMap } = this.props
    if (item.quantity === 0) {
      return <div>{contentMap.out_of_stock.value}</div>
    }

    if (item.oldQuantity) {
      return (
        <div>
          <div>{item.quantity}</div>
          <div className="text-muted small">
            {item.oldQuantity - item.quantity} {contentMap.out_of_stock.value}
          </div>
        </div>
      )
    }
    return <div>{item.quantity}</div>
  }

  getNameCSS = () => {
    const { staticData } = this.props
    return staticData ? "col-3 col-lg-5" : "col-3"
  }

  createProductRows = () => {
    const { language } = this.props
    const { products, cart } = this.state

    return products.map((item, i) => {
      const link = Utils.GetLanguageLink(language, "/shop/" + item.slug)
      const variations = cart[i].variations

      return (
        <div className="row cart-item align-items-center" key={i}>
          <div className="col-12 col-md-3 col-lg-1">
            {this.createThumbnail(item, link)}
          </div>
          <div className={this.getNameCSS()}>{this.createName(item, link)}</div>
          <div className="col-3 col-md-2 text-truncate text-right">
            {this.getQuantity(item)}
          </div>
          <div className="col-3 col-md-2 text-truncate text-right">
            {this.getPrice(item)}
          </div>
          <div className="col-3 col-md-2 text-truncate text-right">
            {this.getTotalPrice(item)}
          </div>
          {this.getAddButton(item, variations)}
          {this.getWishlistButton(item)}
          {this.getRemoveButton(item, variations)}
        </div>
      )
    })
  }

  getTotal = () => {
    const { total, shippingSubGroup } = this.state
    if (!shippingSubGroup) {
      return ""
    }
    return Utils.GetDisplayPrice(total, true)
  }

  getDiscountCss = () => {
    const { errors, formValues, discountCode, discountDisabled } = this.state

    if (errors && errors.includes("discount_code")) {
      return "col-6 form-control forminput-invalid"
    }
    if (!discountDisabled || discountCode === "") {
      return "col-6 form-control"
    }
    if (formValues.discount_code !== "") {
      return "col-6 form-control forminput-valid"
    }
    return "col-6 form-control"
  }

  onCheckoutClick = event => {
    if (event) {
      event.preventDefault()
    }

    const { commonContentMap } = this.props
    const checkoutContentLink = Utils.GetMarkdownLinkFromLink(
      commonContentMap.menu_checkout.value
    )

    navigate(checkoutContentLink)
  }

  onDiscountClick = event => {
    const { discountCode, t } = this.state
    if (event) {
      event.preventDefault()
    }

    this.discountCancelToken = Utils.FetchDiscount(
      discountCode,
      t,
      this.setDiscount
    )
  }

  setDiscount = discount => {
    const { onDiscountChange } = this.props
    const { formValues } = this.state
    let { errors, discountCode } = this.state

    if (!discount || !discount.times_valid || discount.times_valid === 0) {
      errors.push("discount_code")
      discountCode = ""
      formValues.discount_code = ""
    } else {
      errors = errors.filter(item => item !== "discount_code")
      formValues.discount_code = discount.code
    }

    this.setState(
      {
        discountCode: discountCode,
        formValues: formValues,
        errors: errors,
        discountDisabled: true,
      },
      this.fetchProducts
    )
    if (onDiscountChange) {
      onDiscountChange(discount)
    }
  }

  createCheckoutButton = () => {
    const { commonContentMap, staticData } = this.props
    const { checkoutDisabled } = this.state

    if (staticData) {
      return null
    }

    return (
      <button
        className="btn btn-dark col-12 col-lg-2 mt-4 mt-lg-0 text-truncate"
        onClick={this.onCheckoutClick}
        disabled={checkoutDisabled}
      >
        {Utils.GetMarkdownTextFromLink(commonContentMap.menu_checkout.value)}
      </button>
    )
  }

  getTotalCSS = () => {
    const { staticData } = this.props
    return staticData
      ? "col-6 col-lg-8 text-right mb-2"
      : "col-6 text-right mb-2"
  }

  createDiscountRow = () => {
    const { commonContentMap } = this.props
    const { discountDisabled, discountCode } = this.state

    return (
      <div className="row align-items-end cart-item">
        <div className="col-6 col-lg-4">
          <label htmlFor="discount_code_div">
            {commonContentMap.discount_code.value}
          </label>
          <div className="row align-items-start" name="discount_code_div">
            <input
              className={this.getDiscountCss()}
              type="text"
              id="discount_code"
              name="discount_code"
              value={discountCode}
              onChange={this.handleChange}
              placeholder={commonContentMap.discount_code.value}
              aria-label={commonContentMap.discount_code.value}
            />
            <button
              className="col-6 btn btn-dark form-control d-flex justify-content-center align-items-center"
              id="apply_discount"
              onClick={this.onDiscountClick}
              disabled={discountDisabled}
            >
              {commonContentMap.button_apply.value}
            </button>
          </div>
        </div>
        <div className={this.getTotalCSS()}>{this.getTotal()}</div>
        {this.createCheckoutButton()}
      </div>
    )
  }

  getEmptyValue = () => {
    const { contentMap } = this.props

    if (contentMap.empty) {
      return contentMap.empty.value
    }
  }

  render() {
    const { cart } = this.state

    if (cart.length === 0) {
      return (
        <div className="container mb-5 cart-empty justify-content-center">
          {this.getEmptyValue()}
        </div>
      )
    }
    return (
      <div className="container text-uppercase">
        {this.createHeader()}
        {this.createProductRows()}
        {this.createShippingRow()}
        {this.createDiscountRow()}
      </div>
    )
  }
}

function compareProductsByID(a, b) {
  if (a.id < b.id) {
    return -1
  }
  if (a.id > b.id) {
    return 1
  }
  return 0
}
